import * as React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { EffectsChain } from "../../Model/Nodes/EffectsChain";
import { BoxSelect, FAButton, Slider } from "../SharedReact/BasicElements";
export class EffectsChainPanel extends React.Component {
    constructor(props) {
        super(props);
        this._deserialiseFunction = () => { this.forceUpdate(); };
        this._effectChanged = this._effectChanged.bind(this);
        this._effectRemoved = this._effectRemoved.bind(this);
        this._newEffect = this._newEffect.bind(this);
        this._moveEffect = this._moveEffect.bind(this);
        this._selectedChainChanged = this._selectedChainChanged.bind(this);
        this._deleteCurrentChain = this._deleteCurrentChain.bind(this);
        this._preGainChanged = this._preGainChanged.bind(this);
        this._postGainChanged = this._postGainChanged.bind(this);
        this._connectionChanged = this._connectionChanged.bind(this);
        this.state = {
            currentChainNumber: 0,
            hidden: false
        };
    }
    get currentChain() {
        if (this.state.currentChainNumber === 0) {
            return this.props.connectionManager.bus;
        }
        return this.props.connectionManager.chains[this.state.currentChainNumber - 1];
    }
    get chainsAndBus() {
        return [this.props.connectionManager.bus].concat(this.props.connectionManager.chains);
    }
    _newEffect(newEffectIndex) {
        this.currentChain.addEffect(this.currentChain.effects.length, EffectsChain.possibleEffects.get(EffectsChainInfo.effectTitles[newEffectIndex])());
        this.setState({ currentChainNumber: this.state.currentChainNumber });
    }
    _effectChanged(effectIndex, propertyIndex, value) {
        let property = this.currentChain.effects[effectIndex].properties[propertyIndex];
        property.value = value;
        this.currentChain.effectNodes[effectIndex][property.propertyName] = value;
        this.setState({ currentChainNumber: this.state.currentChainNumber });
    }
    _effectRemoved(index) {
        this.currentChain.removeEffect(index);
        this.setState({ currentChainNumber: this.state.currentChainNumber });
    }
    _moveEffect(oldIndex, newIndex) {
        this.currentChain.moveEffect(oldIndex, newIndex);
        this.setState({ currentChainNumber: this.state.currentChainNumber });
    }
    _hidePanel() {
        this.setState({ hidden: !this.state.hidden }, () => {
            if (this.state.hidden) {
                this.props.hideShowCallback();
            }
            else {
                setTimeout(() => { this.props.hideShowCallback(); }, 500);
            }
        });
    }
    _selectedChainChanged(index) {
        if (index > this.props.connectionManager.chains.length) {
            this.props.connectionManager.addChain();
        }
        this.setState({ currentChainNumber: index });
    }
    _deleteCurrentChain() {
        this.props.connectionManager.removeChain(this.currentChain.chainName);
        this.setState({ currentChainNumber: 0 });
    }
    _preGainChanged(value) {
        this.currentChain.preGain = value;
    }
    _postGainChanged(value) {
        this.currentChain.postGain = value;
    }
    _connectionChanged(index, value) {
        let curChain = this.currentChain;
        if (curChain !== this.props.connectionManager.bus && this.props.connectionManager.getConnections(curChain)[0] != value) {
            console.log(this.props.connectionManager.getConnections(curChain)[0]);
            this.props.connectionManager.removeAllConnections(curChain);
            this.props.connectionManager.addConnection(curChain, value);
            this.setState({ currentChainNumber: this.state.currentChainNumber });
        }
    }
    componentDidMount() {
        this.props.connectionManager.effectsDeserialised.addListener(this._deserialiseFunction);
    }
    componentWillUnmount() {
        this.props.connectionManager.effectsDeserialised.removeListener(this._deserialiseFunction);
    }
    render() {
        let options = this.chainsAndBus.map(value => { return value.chainName; });
        options.push("New Chain...");
        let curChain = this.currentChain;
        return React.createElement("div", { className: "effectsChainPanel" + (this.state.hidden ? " hidden" : "") },
            React.createElement(FAButton, { title: this.state.hidden ? "Show Effects" : "Hide Effects", className: "effectsChainHideShowButton", iconName: this.state.hidden ? "fa fa-caret-left" : "fa fa-caret-right", onClick: () => { this._hidePanel(); } }),
            React.createElement("div", { className: "effectsChainContent" },
                React.createElement("div", { className: "effectsChainPanelTitle" },
                    React.createElement(BoxSelect, { title: "New Chain", mainButtonClassName: "effectsChainTitleButton", selectButtonClassName: "effectsChainSelectButton", selected: this.state.currentChainNumber, options: options, selectedCallback: this._selectedChainChanged }),
                    React.createElement(FAButton, { title: "Delete Chain", className: "effectsChainButton buttonColorAnim size title", iconName: "fa fa-close", onClick: this._deleteCurrentChain, disabled: curChain.chainName === "Bus" })),
                React.createElement(EffectsChainInfo, { effectsChain: curChain.effects, moveEffect: this._moveEffect, effectPropertyChanged: this._effectChanged, newEffect: this._newEffect, effectRemoved: this._effectRemoved, preGainValue: curChain.preGain, preGainValueChanged: this._preGainChanged, postGainValue: curChain.postGain, postGainValueChanged: this._postGainChanged, connection: this.props.connectionManager.getConnections(curChain)[0], connectionOptions: (curChain === this.props.connectionManager.bus ? ["Context"] : ["Context", "Bus"]), connectionChangedCallback: this._connectionChanged })));
    }
}
class EffectsChainInfo extends React.Component {
    constructor(props) {
        super(props);
        this._onDragEnd = this._onDragEnd.bind(this);
    }
    _onDragEnd(result) {
        if (!result.destination || result.source.index == result.destination.index) {
            return;
        }
        this.props.moveEffect(result.source.index, result.destination.index);
    }
    render() {
        let effects = this.props.effectsChain.map((effect, index) => {
            return React.createElement(ChainEffect, Object.assign({ key: effect.id, effectIndex: index }, effect, { onPropertyChange: this.props.effectPropertyChanged, onDelete: this.props.effectRemoved }));
        });
        return React.createElement("div", { className: "effectsList" },
            React.createElement("div", { className: "effectsListDivider", style: { marginTop: "0px" } }),
            React.createElement("div", { className: "effectProperty range" },
                React.createElement("p", { className: "effectTitleText" }, "Input Gain:"),
                React.createElement(Slider, { value: this.props.preGainValue, min: 0, max: 1, step: 0.01, onRelease: true, onChange: this.props.preGainValueChanged })),
            React.createElement("div", { className: "effectProperty range " },
                React.createElement("p", { className: "effectTitleText" }, "Output Gain:"),
                React.createElement(Slider, { value: this.props.postGainValue, min: 0, max: 1, step: 0.01, onRelease: true, onChange: this.props.postGainValueChanged })),
            React.createElement("div", { className: "effectProperty list" },
                React.createElement("p", { className: "effectTitleText" }, "Output:"),
                React.createElement(BoxSelect, { mainButtonClassName: "", boxSelectTitle: this.props.connection, options: this.props.connectionOptions, selectedCallback: this.props.connectionChangedCallback })),
            React.createElement("div", { className: "effectsListDivider" }),
            React.createElement("p", { className: "effectTitleText" }, "Effects:"),
            React.createElement(DragDropContext, { onDragEnd: this._onDragEnd },
                React.createElement(Droppable, { droppableId: "effectsList" }, (provided, snapshot) => (React.createElement("div", Object.assign({ className: "effectsListDroppable effectsListElement" + (snapshot.isDraggingOver ? " dragging" : ""), ref: provided.innerRef }, provided.droppableProps),
                    effects,
                    provided.placeholder)))),
            React.createElement(BoxSelect, { mainButtonClassName: "effectsChainButton buttonColorAnim dropdownButton", title: "New Effect", options: EffectsChainInfo.effectTitles, selectedCallback: this.props.newEffect },
                React.createElement("i", { className: "fa fa-plus" })));
    }
}
EffectsChainInfo.effectTitles = Array.from(EffectsChain.possibleEffects.keys());
class ChainEffect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: true
        };
        this._contentRef = React.createRef();
    }
    render() {
        return React.createElement(Draggable, { draggableId: this.props.id, index: this.props.effectIndex }, (provided, snapshot) => (React.createElement("div", Object.assign({ className: "chainEffect" + (snapshot.isDragging ? " dragging" : ""), ref: provided.innerRef }, provided.draggableProps),
            React.createElement("div", Object.assign({ className: "chainEffectTitle" }, provided.dragHandleProps),
                React.createElement(FAButton, { className: "effectsChainButton buttonColorAnim size", title: this.state.collapsed ? "Expand" : "Collapse", iconName: "fa " + (this.state.collapsed ? "fa-chevron-right" : "fa-chevron-down"), onClick: () => this.setState({ collapsed: !this.state.collapsed }) }),
                React.createElement("p", { className: "effectTitleText", style: { marginRight: "5px" } }, this.props.effectType),
                React.createElement(FAButton, { className: "effectsChainButton buttonColorAnim size", title: "Delete Effect", iconName: "fa fa-close", onClick: () => { this.props.onDelete(this.props.effectIndex); } })),
            React.createElement("div", { ref: this._contentRef, className: "effectContent", style: { maxHeight: (this.state.collapsed ? undefined : (this._contentRef.current ? this._contentRef.current.scrollHeight + "px" : "initial")) } }, this.props.properties.map((property, index) => {
                if (property.editable) {
                    switch (property.type) {
                        case "number":
                            if (property.hasOwnProperty("min")) {
                                return React.createElement(RangeEffectProperty, Object.assign({ key: index, effectIndex: this.props.effectIndex, propertyIndex: index }, property, { onChange: this.props.onPropertyChange }));
                            }
                            else {
                                return React.createElement(NumberEffectProperty, Object.assign({ key: index, effectIndex: this.props.effectIndex, propertyIndex: index }, property, { onChange: this.props.onPropertyChange }));
                            }
                        case "string":
                            return React.createElement(StringEffectProperty, Object.assign({ key: index, effectIndex: this.props.effectIndex, propertyIndex: index }, property, { onChange: this.props.onPropertyChange }));
                        case "boolean":
                            return React.createElement(BooleanEffectProperty, Object.assign({ key: index, effectIndex: this.props.effectIndex, propertyIndex: index }, property, { onChange: this.props.onPropertyChange }));
                        case "list":
                            return React.createElement(ListEffectProperty, Object.assign({ key: index, effectIndex: this.props.effectIndex, propertyIndex: index }, property, { onChange: this.props.onPropertyChange }));
                        default:
                            console.log("Unknown property type: " + property.type);
                            return null;
                    }
                }
            })))));
    }
}
function capitalise(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}
class NumberEffectProperty extends React.PureComponent {
    render() {
        let nameToUse = capitalise(this.props.displayName ? this.props.displayName : this.props.propertyName) + ":";
        return React.createElement("div", { className: "effectProperty number" },
            React.createElement("p", null, nameToUse),
            React.createElement("input", { type: "number", name: nameToUse, value: this.props.value, step: this.props.step, onChange: (event) => { this.props.onChange(this.props.effectIndex, this.props.propertyIndex, event.target.value); } }));
    }
}
class RangeEffectProperty extends React.PureComponent {
    render() {
        let nameToUse = capitalise(this.props.displayName ? this.props.displayName : this.props.propertyName) + ":";
        return React.createElement("div", { className: "effectProperty range" },
            React.createElement("p", null, nameToUse),
            React.createElement(Slider, { onRelease: true, min: this.props.min, max: this.props.max, step: this.props.step, value: this.props.value, onChange: (value) => { this.props.onChange(this.props.effectIndex, this.props.propertyIndex, value); } }));
    }
}
class StringEffectProperty extends React.PureComponent {
    render() {
        let nameToUse = capitalise(this.props.displayName ? this.props.displayName : this.props.propertyName) + ":";
        return React.createElement("div", { className: "effectProperty string" },
            React.createElement("p", null, nameToUse),
            React.createElement("input", { type: "text", name: nameToUse, value: this.props.value, onChange: (event) => { this.props.onChange(this.props.effectIndex, this.props.propertyIndex, event.target.value); } }));
    }
}
class BooleanEffectProperty extends React.PureComponent {
    render() {
        let nameToUse = capitalise(this.props.displayName ? this.props.displayName : this.props.propertyName) + ":";
        return React.createElement("div", { className: "effectProperty boolean" },
            React.createElement("p", null, nameToUse),
            React.createElement("input", { type: "checkbox", name: nameToUse, checked: this.props.value, onChange: (event) => { this.props.onChange(this.props.effectIndex, this.props.propertyIndex, event.target.checked); } }));
    }
}
class ListEffectProperty extends React.PureComponent {
    render() {
        let nameToUse = capitalise(this.props.displayName ? this.props.displayName : this.props.propertyName) + ":";
        return React.createElement("div", { className: "effectProperty list" },
            React.createElement("p", null, nameToUse),
            React.createElement(BoxSelect, { selected: this.props.options.indexOf(this.props.value), options: this.props.options, selectedCallback: (newIndex) => { this.props.onChange(this.props.effectIndex, this.props.propertyIndex, this.props.options[newIndex]); } }));
    }
}
//# sourceMappingURL=EffectsChainPanel.js.map